import type { CustomTheme } from '.'

export const customTheme: CustomTheme = {
  colors: {
    // primary: {
    //   DEFAULT: '#e2001a',
    //   '50': '#fef5f6',
    //   '100': '#fbd8dc',
    //   '200': '#f7b4bc',
    //   '300': '#f18692',
    //   '400': '#ee6978',
    //   '500': '#e8374b',
    //   '600': '#d50018',
    //   '700': '#ad0013',
    //   '800': '#940010',
    //   '900': '#6e000c',
    // },
    // gray: {
    //   50: '#F8F9FC',
    //   100: '#EEF1F7',
    //   200: '#E4E8F0',
    //   300: '#CCD3DF',
    //   400: '#A3AABF',
    //   500: '#748095',
    //   600: '#4C5567',
    //   700: '#2E3647',
    //   800: '#1B202B',
    //   900: '#181922',
    // },
  },
  semanticTokens: {
    colors: {
      // 'chakra-body-text': { _light: 'gray.800', _dark: 'whiteAlpha.900' },
      // 'chakra-body-bg': { _light: 'white', _dark: 'gray.800' },
      // 'chakra-border-color': { _light: 'gray.200', _dark: 'whiteAlpha.300' },
      // 'chakra-placeholder-color': {
      //   _light: 'gray.500',
      //   _dark: 'whiteAlpha.400',
      // },
      // // Badge
      // 'badge-bg': { default: 'gray.500' },
      // // Checkbox
      // 'checkbox-color': { default: 'gray.800' },
      // 'checkbox-border': { default: 'gray.500' },
      // 'checkbox-border-checked': { default: 'white' },
      // 'checkbox-shadow-color': { default: 'green.700' },
      // 'checkbox-shadow-highlight-color': { default: 'green.500' },
      // // Form control
      // 'form-helper-text-color': { default: 'gray.800' },
      // // Heading
      // 'heading-color': { default: 'gray.800' },
      // // Input
      // 'input-bg': 'gray.50',
      // 'input-border': 'gray.900',
      // 'input-focused-border': 'gray.900',
      // 'input-color': 'gray.800',
      // // Label
      // 'label-color': 'gray.800',
      // // Menu
      // 'menu-item-color': 'gray.800',
      // // Select
      // 'select-bg': 'gray.50',
      // 'select-border': 'gray.900',
      // 'select-color': 'gray.800',
      // 'select-icon-color': 'gray.500',
      // // Text
      // 'text-color': 'gray.800',

      // // Components
      // // Steps
      // 'steps-container-bg': 'gray.800',
      // 'step-bg': 'gray.100',
      // 'step-number-border': 'gray.100',
      // 'step-number-bg': 'transparent',
      // 'step-number-color': 'gray.100',
      // 'step-number-passed-bg': 'gray.100',
      // 'step-number-passed-color': 'gray.800',
      // 'step-divider-bg': 'gray.600',
      // // Steps progress
      // 'step-progress-passed-bg': 'gray.500',
      // // Insurance Info Form Control
      // 'insurance-info-label-color': 'gray.100',
      // 'insurance-info-label-bg': 'gray.100',
      // 'insurance-info-value-color': 'gray.200',
      // // Insurance Value
      // 'insurance-value-border': 'gray.300',
      // // Wizzard header
      // 'wizzard-header-bg': 'gray.800',
      // 'wizzard-header-history-timeline-dot-bg': 'gray.300',
      // 'wizzard-header-history-timeline-line-bg': 'gray.700',
      // 'wizzard-header-history-timeline-label-color': 'gray.200',
      // 'wizzard-header-history-timeline-user-color': 'gray.400',
      // 'wizzard-header-history-timeline-description-color': 'gray.200',

      'login-bg': '#d92b22'
    },
  },
}
